import { api } from '@/api';
import { type BookingSearchRequestDTO } from '@/types/dto/agent';

export const PROFILE_BOOKINGS_PAGE_SIZE = 10;

export const fetchProfileBookings = async (
  request: Omit<
    BookingSearchRequestDTO,
    'purchaserPassengerEmail' | 'concessionVoucherSearchType'
  >,
  offset?: number
) => {
  const data = (
    await api.agentApi.BookingsSearch_SearchBookingsCustom(
      { Limit: PROFILE_BOOKINGS_PAGE_SIZE, Offset: offset ?? 0 },
      {
        concessionVoucherSearchType: 'ALL',
        ...request,
      }
    )
  ).data;

  return {
    data: data.bookingsSearchResults ?? [],
    totalCount: data.totalCount,
  };
};
